module.exports = __webpack_public_path__ + "img/menu.53c6ad69.png";